import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useWarehouseActiveOrders = (distributor, term = null, item = null) => useQuery({ queryKey: [`w-orders`, distributor, term, item], queryFn: async () => {
    if(!distributor) return null
    const callback = await API.get(`/warehouse/${distributor}/orders${term ? `?term=${term}` : ''}${term && item ? `&item=${item}` : (item ? `?item=${item}` : '') }`)
    return callback?.data
}, staleTime: 1000 * 60 * 3})

export default useWarehouseActiveOrders
